<template>
  <input
    ref="bInput"
    v-model="query"
    type="search"
    class="form-control form-control-sm search-box"
    :placeholder="$t('message.generic.search')">
</template>

<script>
/**
 * Debounced free-text input for REST-backed searches. Same public surface as
 * DebouncedAlgoliaSearchBox (`delay`, `defaultValue`, `setFocusInput()`, `setValue()`),
 * but it emits the term instead of refining an InstantSearch widget.
 */
export default {
  name: 'DebouncedSearchBox',
  props: {
    delay: {
      type: Number,
      default: 300
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localQuery: '',
      timeoutId: null
    }
  },
  computed: {
    query: {
      get() {
        return this.localQuery
      },
      set(val) {
        clearTimeout(this.timeoutId)
        this.localQuery = val
        this.timeoutId = setTimeout(() => {
          this.$emit('search', this.localQuery)
        }, this.delay)
      }
    }
  },
  watch: {
    defaultValue: function (newVal) {
      if (newVal !== this.localQuery) {
        this.localQuery = newVal
      }
    }
  },
  mounted() {
    this.localQuery = this.defaultValue
  },
  destroyed() {
    clearTimeout(this.timeoutId)
  },
  methods: {
    setFocusInput() {
      this.$refs.bInput.focus()
    },
    setValue(query) {
      this.query = query
    }
  }
}
</script>
